import React, { useState } from 'react';
import './HowCare360WorksPage.css';
import './ServicesPage.css';

const HowCare360WorksPage = () => {
  const [openIndices, setOpenIndices] = useState(new Set());

  const toggleIndex = (index) => {
    setOpenIndices((prev) => {
      const next = new Set(prev);
      if (next.has(index)) next.delete(index);
      else next.add(index);
      return next;
    });
  };

  const processAccordionItems = [
    {
      title: 'Practice & EHR Evaluation',
      content: (
        <>
          <p>We begin with a comprehensive assessment of your current clinical workflows, staffing structure, payer mix, and EHR capabilities.</p>
          <p className="accordion-subheading">This includes:</p>
          <ul className="accordion-bullets">
            <li>Review of EMR documentation workflows</li>
            <li>Analysis of billing patterns and reimbursement trends</li>
            <li>Evaluation of patient population eligibility</li>
            <li>Compliance and audit readiness review</li>
            <li>Infrastructure assessment for RPM integration</li>
          </ul>
          <p className="accordion-subheading">Outcome:</p>
          <p>A clear roadmap identifying operational gaps, revenue opportunities, and implementation readiness.</p>
        </>
      )
    },
    {
      title: 'Custom Program Design',
      content: (
        <>
          <p>Based on our evaluation, we design a fully customizable care management program aligned with your practice model.</p>
          <p className="accordion-subheading">This includes:</p>
          <ul className="accordion-bullets">
            <li>Selection of appropriate care management models (CCM, PCM, RPM, TCM, PIN)</li>
            <li>Documentation templates tailored to your EMR</li>
            <li>Minute tracking and billing workflows</li>
            <li>Patient engagement strategy</li>
            <li>Compliance safeguards and regulatory alignment</li>
          </ul>
          <p>No cookie-cutter frameworks. Every program is engineered to fit your environment.</p>
        </>
      )
    },
    {
      title: 'Clinical Staffing & Workforce Integration',
      content: (
        <>
          <p>We recruit, screen, and assign appropriately credentialed clinical professionals (RN, LPN, MA, NP) based on your practice needs.</p>
          <p className="accordion-subheading">Our team:</p>
          <ul className="accordion-bullets">
            <li>Provides structured onboarding tailored to your EMR and patient portal</li>
            <li>Delivers training aligned with CMS and regulatory guidelines</li>
            <li>Integrates seamlessly into your existing workflows</li>
            <li>Supports both onsite and remote staffing models</li>
          </ul>
          <p>Once assigned, our clinicians receive continuous education and operational oversight to ensure consistent documentation quality, engagement performance, and compliance integrity.</p>
        </>
      )
    },
    {
      title: 'Implementation & Operational Integration',
      content: (
        <>
          <p>We work directly with your leadership and staff to integrate the program into daily operations.</p>
          <p className="accordion-subheading">This includes:</p>
          <ul className="accordion-bullets">
            <li>Workflow mapping</li>
            <li>EMR configuration guidance</li>
            <li>Staff education sessions</li>
            <li>Revenue tracking dashboards</li>
            <li>Quality monitoring systems</li>
          </ul>
          <p>We do not operate as an external vendor - we embed into your infrastructure.</p>
        </>
      )
    },
    {
      title: 'Ongoing Optimization & Oversight',
      content: (
        <>
          <p>After launch, we continuously monitor performance and refine processes to maximize outcomes.</p>
          <p className="accordion-subheading">This includes:</p>
          <ul className="accordion-bullets">
            <li>Patient engagement metrics</li>
            <li>Reimbursement tracking</li>
            <li>Audit readiness monitoring</li>
            <li>Workflow refinement</li>
            <li>Regulatory updates and compliance alignment</li>
          </ul>
          <p>Solace Care 360 evolves with your practice - ensuring long-term sustainability.</p>
        </>
      )
    }
  ];

  return (
    <div className="how-care-360-page">
      <div className="page-header how-care-360-header">
        <div className="container">
          <h1>How Care 360 Works</h1>
          <p>We assess, design, implement, and optimize a care management program tailored to your practice.</p>
        </div>
      </div>

      <section className="services-accordion-section services-process-accordion">
        <div className="accordion-list">
          {processAccordionItems.map((item, index) => (
            <div key={index} className="accordion-item">
              <button
                className="accordion-header"
                onClick={() => toggleIndex(index)}
              >
                {item.title}
                <span className="accordion-icon">{openIndices.has(index) ? '−' : '+'}</span>
              </button>
              {openIndices.has(index) && (
                <div className="accordion-content">
                  {item.content}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default HowCare360WorksPage;
